import React from "react";

const StyledXlText = ({ children, fontColor }) => {
  return (
    <p className={`text-xl font-inter font-medium ${fontColor}`}>{children}</p>
  );
};

export default StyledXlText;
